import { pipe } from 'ramda';
import styled from 'styled-components';
import {
  Grid,
  withEditingMask,
  withExternalFilter,
  withSingleClickEdit,
} from 'components/atoms/grid';
import { withStylePreferenceProvider } from 'components/atoms/style-preference-context';

export const StyledGrid = styled(Grid)`
  .ag-row {
    border-color: var(--table-border-color);
  }
  .ag-overlay-no-rows-wrapper {
    display: flex;
    text-align: unset;
    pointer-events: auto;
  }
  .ag-pinned-left-cols-container {
    padding: 0 !important;
  }
  .ag-cell-last-left-pinned > .ag-react-container {
    align-self: stretch;
  }
`;

export const ProjectListGrid = pipe(
  pipe(
    () => StyledGrid,
    withExternalFilter,
    withSingleClickEdit,
    withStylePreferenceProvider({ size: 'large' }),
    withEditingMask,
  ),
)();
